import countries from "data/countries";
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import moment, { duration } from "moment";
import { colors } from "views/tasks/board/utils";

export const getTitle = (key?: string) => {
  if (!key) return "";

  const map: Record<string, string> = {
    pending_at_client: "Pending at Client",
    pending_at_department: "Pending at Department",
    others: "Others",
    on_hold: "On Hold",
    in_progress: "In Progress",
    under_review: "Under Review",
    todo: "Todo",
    completed: "Completed",
    completed_overdue: "Completed (Overdue)",
    issued: "Issued",
    AVAILABLE: "Received",
    UNAVAILABLE: "Not Received",
  };

  // ✅ use map if exists
  if (map[key]) return map[key];

  // ✅ fallback (your logic)
  return key
    .split("_")
    .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
    .join(" ");
};

export const getColor = (status: string) => {
  switch (status) {
    case "todo":
      return colors[0];
    case "in_progress":
      return colors[1];
    case "completed":
      return colors[4];
    case "on_hold":
      return colors[2];
    case "under_review":
      return colors[3];
    default:
      return "secondary";
  }
};

export const capitalizeWords = (key: string) => {

  return key
    .split(' ') // Split the string into an array of words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word and make the rest lowercase
    .join(' '); // Join the words back into a single string
}

export const getFileSize = (size: number) => {
  if (size < 1024) {
    return `${size} Bytes`;
  }
  if (size < 1024 * 1024) {
    return `${(size / 1024).toFixed(2)} KB`;
  }
  if (size < 1024 * 1024 * 1024) {
    return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  }
  if (size < 1024 * 1024 * 1024 * 1024) {
    return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`;
  }
  if (size < 1024 * 1024 * 1024 * 1024 * 1024) {
    return `${(size / (1024 * 1024 * 1024 * 1024)).toFixed(2)} TB`;
  }
  return `${(size / (1024 * 1024 * 1024 * 1024 * 1024)).toFixed(2)} PB`; // Petabytes (just in case)
};


export const getHoursOptions = () => {
  return Array.from(Array(24).keys()).map((_, index) => {
    return {
      label: index <= 9 ? `0${index}` : index?.toString(),
      value: index <= 9 ? `0${index}` : index?.toString(),
    };
  });
};

export const getMinutesOptions = () => {
  return Array.from(Array(60).keys()).map((_, index) => {
    return {
      label: index <= 9 ? `0${index}` : index?.toString(),
      value: index <= 9 ? `0${index}` : index?.toString(),
    };
  });
};

export const getTotalLogHoursDuration = (logs: any[]) => {
  let total = logs.reduce((acc, cur) => {
    return acc + +cur.duration;
  }, 0);

  return moment.utc(total).format("HH:mm");
};

export const totalLogHours = (duration) => {
  return moment.utc(duration).format("HH:mm");
};

export const covertToKb = (size: number, type: "KB" | "MB" | "GB") => {
  if (type === "KB") {
    return size;
  }
  if (type === "MB") {
    return size * 1024;
  }
  return 0;
};

export const fileSizeInKb = (size: number) => {
  return size / 1024;
};

export const getExpenseType = (key: string) => {
  if (key === "PURE_AGENT") return "Pure Agent";
  else if (key === "ADDITIONAL") return "Additional Charges";
  else return "---";
};


export const getTitles = (key: string, toCamelCase: boolean = false) => {
  key = key || "";
  key
    ?.split("_")
    .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
    .join(" ");

  return key
    .split(' ') // Split the string into an array of words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word and make the rest lowercase
    .join(' '); // J
};


export function getCurrentFormattedDateTime() {
  const currentDate = new Date();
  const day = String(currentDate.getDate()).padStart(2, '0');
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // January is 0!
  const year = currentDate.getFullYear();
  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');

  // Format the date as dd-mm-yyyy and time as HH:MM
  const formattedDate = `${day}-${month}-${year}`;
  const formattedTime = `${hours}-${minutes}`; // Colon (:) separator for time

  return `${formattedDate} ${formattedTime}`;
}

export function mobileWithCountry(phone: number, country: any): boolean {
  const countryCode = countries.find((c) => c.label === country);
  if (!countryCode) {
    ;
    return false;
  }

  const phoneNumber = parsePhoneNumberFromString(
    `+${countryCode.phone}${phone}`,
    country
  );

  return phoneNumber?.isValid() ? false : true;
}

